module.exports = __webpack_public_path__ + "img/3-old.22cf3775.webp";